<div class="flex flex-row gap-[0.5rem] items-center">
  <div class="text-[0.6875rem] font-[500] leading-[150%] text-(--p-primary-500)" translate="@@shared-time-span_label"></div>

  @if (formGroup && dataOptions && dataOptionsMap) {
    <form [formGroup]="formGroup" class="flex flex-col">
      <p-select class="min-w-[5.5rem]" #select formControlName="data" [options]="formOptions" optionLabel="label" placeholder="Select">
        <ng-template #selectedItem let-selectedOption>
          @if (selectedOption) {
            <div class="flex items-center gap-2 text-[11px] font-[600]">
                <div [translate]="selectLabel(selectedOption)?.label || ''"></div>
            </div>
          }
        </ng-template>

        <ng-template #dropdownicon>
          @if (select.overlayVisible) {
            <svg-icon class="color-[inherit]" src="icons/icon-accordion-arrow-up.svg" name="icon-accordion-arrow-up"></svg-icon>
          } @else {
            <svg-icon src="icons/icon-accordion-arrow-down.svg" name="icon-accordion-arrow-down"></svg-icon>
          }
        </ng-template>

        <ng-template let-value #item>
              <div class="flex text-[11px] font-[600]">
                  <div [translate]="selectLabel(value)?.label || ''"></div>
              </div>
          </ng-template>
      </p-select>
    </form>
  }
</div>


